import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const getVisiblePages = (currentPage, totalPages) => {
  if (totalPages <= 3) {
    return Array.from({ length: totalPages }, (_, index) => index + 1);
  }

  if (currentPage <= 2) {
    return [1, 2, 3];
  }

  if (currentPage >= totalPages - 1) {
    return [totalPages - 2, totalPages - 1, totalPages];
  }

  return [currentPage - 1, currentPage, currentPage + 1];
};

const CoursePagination = ({ currentPage, totalPages, onPageChange }) => {
  if (totalPages <= 1) {
    return null;
  }

  const visiblePages = getVisiblePages(currentPage, totalPages);
  const showLeftEllipsis = visiblePages[0] > 1;
  const showRightEllipsis = visiblePages[visiblePages.length - 1] < totalPages;

  return (
    <div className="mt-11 flex items-center justify-center gap-3">
      <button
        type="button"
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className="flex h-12 w-12 items-center justify-center rounded-full bg-[#FFEEE8] text-[#FF6636] transition-opacity disabled:cursor-not-allowed disabled:opacity-60"
      >
        <ChevronLeft size={24} strokeWidth={2.25} />
      </button>

      <div className="flex items-center  text-sm font-medium  text-[#1D2026]">
        {showLeftEllipsis ? <span className="text-[#1D2026]">...</span> : null}

        {visiblePages.map((page) => (
          <button
            key={page}
            type="button"
            onClick={() => onPageChange(page)}
            className={`w-12 h-12 rounded-full  text-center transition-colors ${
              page === currentPage
                ? "bg-[#FF6636] text-white"
                : "bg-transparent text-[#1D2026]"
            }`}
          >
            {String(page).padStart(2, "0")}
          </button>
        ))}

        {showRightEllipsis ? <span className="text-[#1D2026]">...</span> : null}
      </div>

      <button
        type="button"
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="flex h-12 w-12 items-center justify-center rounded-full bg-[#FFEEE8] text-[#FF6636] transition-opacity disabled:cursor-not-allowed disabled:opacity-60"
      >
        <ChevronRight size={24} strokeWidth={2.25} />
      </button>
    </div>
  );
};

export default CoursePagination;
